<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.4 14.16" class="icon">
        <title>mail</title>
        <path d="M19.56,12.65,14,7.08,19.56,1.5Zm-18.21.67L7,7.67l2,2a1.71,1.71,0,0,0,1.21.47,1.67,1.67,0,0,0,1.2-.47l2-2L19,13.32ZM.84,1.51,6.41,7.08.84,12.65ZM19,.84,10.9,9a1,1,0,0,1-.71.27A1,1,0,0,1,9.48,9L1.36.84Zm1.37.76A1.6,1.6,0,0,0,18.8,0H1.6A1.6,1.6,0,0,0,0,1.6v11a1.6,1.6,0,0,0,1.6,1.6H18.8a1.6,1.6,0,0,0,1.6-1.6Z"
              v-bind:style="{fill: color}"/>
    </svg>
</template>

<script>
    export default {
        name: "IconMail",

        props: {
            color: {
                type: String,
                default: '#231f20'
            }
        }
    }
</script>
